import create from './create';

const accounts = create();
const { login } = accounts;

export default login;
